import { Component, DoCheck, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ClientMessages } from '@hub/generated/_messages';
import { Subscription } from 'rxjs';
import { ModelError } from '@hub/models/ModelError';

@Component({
  selector: "error-message",
  templateUrl: "error-message.component.html"
})
export class ErrorMessageComponent implements OnInit, OnDestroy, DoCheck {
  constructor() {}
  errorMessage: string;
  requiredValidationMessage: string = ClientMessages.RequiredValidationMessage;
  subscription: Subscription;
  wrongPattern = "Used wrong pattern";
  isTouched: boolean = false;
  @Input()
  set control(c: FormControl) {
    this.errorMessage = "";
    this._control = c;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = c.statusChanges.subscribe(value => {
      this.isTouched = false;
      this.updateMessage();
    });
  }
  get control() {
    return this._control;
  }
  @Input() messages: { [key: string]: string };
  @Input("key") public key: string;
  @Input("errors")
  public set errors(errors: ModelError[]) {
    if (!!errors && Array.isArray(errors) && errors.length > 0) {
      if (
        !!this.key &&
        errors.some(x => x.Key.toLowerCase() === this.key.toLowerCase())
      ) {
        let error = errors.find(
          x => x.Key.toLowerCase() === this.key.toLowerCase()
        );
        if (error.Messages.length > 0) {
          this.errorMessage = error.Messages[0];
          this.isTouched = true;
        }
      }
    } else {
      this.updateMessage();
    }
  }
  private _control;

  ngOnInit() {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngDoCheck(): void {
    if (!this.isTouched && this.control && this.control.touched) {
      this.updateMessage();
      this.isTouched = true;
    }
  }

  private updateMessage() {
    if (
      this.control.hasError("required") &&
      (this.control.touched || this.control.dirty)
    ) {
      this.errorMessage = ClientMessages.RequiredValidationMessage;
    } else if (
      this.control.hasError("pattern") &&
      (this.control.touched || this.control.dirty)
    ) {
      this.errorMessage =
        this.messages && this.messages.pattern
          ? this.messages.pattern
          : this.wrongPattern;
    } else if (
      this.control.hasError("maxlength") &&
      (this.control.touched || this.control.dirty)
    ) {
      this.errorMessage = "The maximum length is " + this.control.getError('maxlength').requiredLength + " characters";
    } else if (
      this.control.hasError("max") &&
      (this.control.touched || this.control.dirty)
    ) {
      this.errorMessage = "The maximum value accepted is " + this.control.getError('max').max;
    } else if (
      this.control.hasError("min") &&
      (this.control.touched || this.control.dirty)
    ) {
      this.errorMessage = "The minimum value accepted is " + this.control.getError('min').min;
    } else if (
      this.control.hasError("notObject") &&
      (this.control.touched || this.control.dirty)
    ) {
      this.errorMessage = "Input must be a object.";
    } else if (
      this.control.hasError("objectRequired") &&
      (this.control.touched || this.control.dirty)
    ) {
      this.errorMessage = ClientMessages.RequiredValidationMessage;
    } else {
      this.errorMessage = null;
    }
  }
}
